import { getTableColumns } from 'utils/getTableColumns';

import { IGetColumns } from './types';

export const getColumns = ({ onFilter, onRemove, columnsList }: IGetColumns) =>
  getTableColumns({ fetchedColumns: columnsList, onFilter, onRemove });
